import { useMemo } from "react";
import { useLeaseCompStore } from "..";
import ILeaseComp from "../interfaces/ILeaseComp";
import useLeaseCompsWithFocusArea from "./useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "./useLeaseCompsWithGlobalFilters";

export default function (): ILeaseComp[] {
    const leaseCompStore = useLeaseCompStore();
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(leaseCompStore.leaseComps));

    return useMemo(() => {
        return leaseCompStore.editedLeaseCompId ? leaseComps.filter((lc) => lc.id !== leaseCompStore.editedLeaseCompId) : leaseComps
    }, [leaseComps, leaseCompStore.editedLeaseCompId]);
}
